"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geofence = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const GeoModelCommon_1 = require("./GeoModelCommon");
const debug = process.env.REACT_APP_DEBUG && false;
const typeName = 'Geofence';
class Geofence extends GeoModelCommon_1.GeoModelCommon {
    constructor(ob) {
        super({ ...ob, type: ob.type ?? typeName });
        if (!ob.points) {
            debug && console.log('Geofence assigned empty points', this);
            this.points = [];
        }
        else {
            this.points = ob.points;
        }
        if (this.points.length > 0) {
            if (this.points.length > 2) {
                (0, iotv_v3_types_1.makeIPathToIGeofence)(this.points);
            }
            /** Turf Array has lng before lat */
            //const pArray: TurfPosition[] = this.points.filter(({ lat, lng }) => isNonNaNNumber(lat) && isNonNaNNumber(lng)).map(({ lat, lng }) => [lng, lat])
            //const xCenter: TurfPosition = center(points(pArray)).geometry.coordinates
            //this.location = convertTurfPointsToGLatLng(xCenter)
            //this.dsk = convertLatLngLocationToId(this.location, this.cellLevel)
        }
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            points: {
                type: 'object',
            },
        };
    }
}
exports.Geofence = Geofence;
